export var captureException = function (error, context) {
    if (process.env.NODE_ENV !== 'production') {
        console.error('Sentry fallback captureException:', error, context);
    }
};
export var init = function (_options) { };
export var browserTracingIntegration = function () { return ({}); };
export var replayIntegration = function () { return ({}); };
